import Swal from "sweetalert2";
import {getCsrfToken} from "../../plugins/get-csrf-token";
import makeId from "../../pages/survey/questions/make-id";

export function attachCompanyStatements($context) {
    if (!$context.length) {
        return;
    }

    const csrfToken = getCsrfToken();

    const companyStatementsUrl = $context.find('input.object-choose-radio:checked').data('company-statement-url');
    const $companyStatementsListContainer = $context.find('.company-statements-list-container');
    const surveyLanguageId = $context.closest('form').children('input[name="survey_language_id"]').val();
    const questionPartCategoryId = $context.find('input.object-choose-radio:checked').val();

    // Show list of company statements from database
    $.ajax({
        type: 'GET',
        url: companyStatementsUrl,
        beforeSend: function () {
            // Add loading spinner
            $companyStatementsListContainer.html(`
                <div class="text-center">
                    <div class="spinner-border" role="status"></div>
                    <strong class="d-block">Loading data, please wait...</strong>
                </div>
            `);
        },
        success: function (statementsListHTML) {
            const $statementsListHTML = $(statementsListHTML);
            const mainKeyName = $companyStatementsListContainer.data('main-key-name');

            // Add part id in statements input name
            $statementsListHTML.find('[name]').each(function(index, el) {
                const name = $(el).prop('name');
                const nameWithPartNumber = mainKeyName + name;
                $(el).prop('name', nameWithPartNumber);
            });

            // Add statements list HTML do container
            $companyStatementsListContainer.html($statementsListHTML);
        },
        error: function () {
            // Hide loading spinner by reset company statements container
            $companyStatementsListContainer.html('');

            // Show error message
            showNotification(
                $companyStatementsListContainer,
                'The statement list could not be displayed. Please try again later.',
                'danger'
            );
        },
    });

    // Add new statement to company statements list
    $($context).on('click', '.add-new-company-statement', function (event) {
        event.preventDefault();

        const $inputGroup = $(this).closest('.input-group');
        const statementName = $inputGroup.children('input[type=text]').val();

        // The statement name is required
        if (!!statementName) {

            // Ajax post data to saved in database
            $.ajax({
                type: "POST",
                headers: {'X-CSRF-TOKEN': csrfToken},
                url: companyStatementsUrl,
                data: {
                    name: statementName,
                },
                beforeSend: function () {
                    // Block button and statement add field
                    $inputGroup.children('input, button').prop('disabled', true);

                    // Add loading spinner to icon button
                    $inputGroup.find('button i')
                        .removeClass('bx-plus')
                        .addClass('bx-spin bx-loader-alt')
                },
                success: function (newStatementHTML) {
                    // Show success notification message under statement add field
                    showNotification(
                        $inputGroup.parent(),
                        'The statement has been saved.',
                        'success'
                    );

                    // Remove paragraph with empty list message if exists
                    $companyStatementsListContainer.children('p').remove();

                    // Add new statement do company statements list
                    $companyStatementsListContainer.append(newStatementHTML);

                    // Reset text input value
                    $inputGroup.children('input[type=text]').val('');
                },
                error: function () {
                    // Show error notification message under statement add field
                    showNotification(
                        $inputGroup.parent(),
                        'The statement has not been saved. Please try again later.',
                        'danger'
                    );
                },
                complete: function () {
                    // Remove loading spinner in icon button
                    $inputGroup.find('button i')
                        .removeClass('bx-spin bx-loader-alt')
                        .addClass('bx-plus')

                    // Unlock button and reset statement add field
                    $inputGroup.find('input, button').prop('disabled', false);
                }
            });
        } else {
            // Show notification: name is required
            showNotification(
                $inputGroup.parent(),
                'The statement name cannot be empty.',
                'danger'
            );
        }
    });

    // Edit company statement: show edit controls
    $($context).on('click', 'button[data-edit-statement]', function (event) {
        event.preventDefault();

        const $editButton = $(this);
        const $statement = $editButton.closest('.statements-list-item');
        const $saveButton = $statement.find('button[data-save-statement]');
        const $cancelButton = $statement.find('button[data-cancel-statement]');
        const $deleteButton = $statement.find('button[data-delete-statement]');
        const statementName = $statement.find('.statement-name').text();

        // Show edit buttons, hide other buttons
        $saveButton.removeClass('hide');
        $cancelButton.removeClass('hide');
        $deleteButton.addClass('hide');
        $editButton.addClass('hide');

        // Hide statement name
        $statement.find('.statement-name').hide();

        // Show input text with statement name
        const statementNameInput = `<input type="text" class="form-control py-1"/>`;
        let $statementNameInput = $(statementNameInput)
            .css('height', 'auto')
            .val(statementName);
        $statement.find('.statements-name').append($statementNameInput);
    });

    // Edit company statement: cancel edit
    $($context).on('click', 'button[data-cancel-statement]', function (event) {
        event.preventDefault();

        const $cancelButton = $(this);
        const $statement = $cancelButton.closest('.statements-list-item');
        const $saveButton = $statement.find('button[data-save-statement]');
        const $editButton = $statement.find('button[data-edit-statement]');
        const $deleteButton = $statement.find('button[data-delete-statement]');

        // Show edit and delete buttons, hide other buttons
        $saveButton.addClass('hide');
        $cancelButton.addClass('hide');
        $deleteButton.removeClass('hide');
        $editButton.removeClass('hide');

        // Show statement name
        $statement.find('.statement-name').show();

        // Remove input text
        $statement.find('.statements-name input[type=text]').remove();
    });

    // Edit company statement: save statement name
    $($context).on('click', 'button[data-save-statement]', function (event) {
        event.preventDefault();

        const $saveButton = $(this);
        const $statement = $saveButton.closest('.statements-list-item');
        const $statementNameEditInput = $statement.find('.statements-name input[type=text]');
        const updateStatementUrl = $(this).data('update-statement-url');
        const statementName = $statementNameEditInput.val();
        const $cancelButton = $statement.find('button[data-cancel-statement]');
        const $editButton = $statement.find('button[data-edit-statement]');
        const $deleteButton = $statement.find('button[data-delete-statement]');

        // Ajax put data
        $.ajax({
            type: "PUT",
            headers: {'X-CSRF-TOKEN': csrfToken},
            url: updateStatementUrl,
            data: {
                name: statementName,
            },
            beforeSend: function () {
                // Block button and statement edit field
                $saveButton.prop('disabled', true);
                $statementNameEditInput.prop('disabled', true);

                // Add loading spinner to icon button
                $saveButton.children('i')
                    .removeClass('bx-save')
                    .addClass('bx-spin bx-loader-alt');
            },
            success: function () {
                // Update name in statement div
                $statement.find('.statement-name').text(statementName);
            },
            error: function () {
                // Show error notification message under statement add field
                showNotification(
                    $companyStatementsListContainer,
                    'The statement has not been saved. Please try again later.',
                    'danger'
                );
            },
            complete: function () {
                // Unlock button and remove statement edit field
                $saveButton.prop('disabled', false);
                $statementNameEditInput.remove();

                // Remove loading spinner
                $saveButton.children('i')
                    .addClass('bx-save')
                    .removeClass('bx-spin bx-loader-alt');

                // Show edit and delete buttons, hide other buttons
                $saveButton.addClass('hide');
                $cancelButton.addClass('hide');
                $deleteButton.removeClass('hide');
                $editButton.removeClass('hide');

                // Show statement name
                $statement.find('.statement-name').show();

                // Remove input text
                $statementNameEditInput.remove();
            },
        });
    });

    // Remove company statement
    $($context).on('click', 'button[data-delete-statement]', function (event) {
        event.preventDefault();

        const $statement = $(this).closest('.statements-list-item');
        const deleteStatementUrl = $(this).data('delete-statement-url');

        Swal.fire({
            title: 'Remove',
            text: 'Do you really want to delete this statement?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: '<i class="label-icon bx bx-trash"></i> Delete',
            cancelButtonText: '<i class="label-icon bx bx-arrow-back"></i> Cancel',
            customClass: {
                confirmButton: 'btn btn-label btn-danger btn-min-width',
                cancelButton: 'btn btn-label btn-primary btn-min-width',
            }
        }).then((result) => {
            if (result.value !== true) {
                return;
            }

            // Ajax delete statement
            $.ajax({
                type: "DELETE",
                headers: {'X-CSRF-TOKEN': csrfToken},
                url: deleteStatementUrl,
                success: function () {
                    // Remove statement from list
                    $statement.slideUp().remove();
                },
                error: function (xhr, status, error) {
                    // Show error notification message under statements list
                    showNotification(
                        $companyStatementsListContainer,
                        'The statement could not be deleted. Please try again later.',
                        'danger'
                    );
                },
            });
        });
    });
}

function showNotification(container, message, type) {
    const notificationHtml = getAlertHtml(message, type);
    const notificationId = makeId(8);
    const $notification = $(notificationHtml).prop('id', notificationId);

    $(container).append($notification);

    const notification = document.getElementById(notificationId);
    $(notification).delay(4000).slideUp(400, function() {
        $(this).alert('close');
    });
}

// Generate alert html tags
function getAlertHtml(message, type) {
    return `<div class="alert alert-`+type+` alert-dismissible fade show" role="alert">
                `+message+`
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>`;
}
